import { render, staticRenderFns } from "./HistorialHojasBienvenida.vue?vue&type=template&id=2d29e90c"
import script from "./HistorialHojasBienvenida.vue?vue&type=script&lang=js"
export * from "./HistorialHojasBienvenida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports